export default {
  WEBSITE_LOAD: 'WEBSITE_LOAD',
  WEBSITE_CREATED: 'WEBSITE_CREATED',
  WEBSITE_FETCHED: 'WEBSITE_FETCHED',
  WEBSITES_FETCHED: 'WEBSITES_FETCHED',
};
